// "Autorizacao de Compra" (crediario): gera o PDF no backend (bobina 55mm,
// mesmo mecanismo do cupom NFC-e formato 'cartao') e abre pra impressao.
// O HTML/CSS do documento mora em @fiodecobre/shared (print/autorizacao) pra
// ser renderizado via Puppeteer no servidor — window.print() do navegador
// ignorava o @page e a impressao saia cortada na maquina de cartao.

import { getToken } from '../lib/api';
import type { AutorizacaoData, ItemAutorizacao } from '@fiodecobre/shared';

export type { AutorizacaoData, ItemAutorizacao };

export async function imprimirAutorizacao(data: AutorizacaoData): Promise<void> {
  // Abre a janela ANTES do await — sem isso o browser bloqueia o window.open
  // disparado depois de uma promise (perde o "user gesture").
  const win = window.open('', '_blank', 'width=320,height=620');
  try {
    const token = getToken();
    const r = await fetch('/api/orcamentos/autorizacao-pdf', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ ...data, data: data.data.toISOString() }),
    });
    if (!r.ok) {
      let msg = String(r.status);
      try { msg = (await r.json()).erro || msg; } catch { /* ignore */ }
      throw new Error(msg);
    }
    const blob = await r.blob();
    const url = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
    if (win) win.location.href = url;
    else window.open(url, '_blank');
  } catch (e) {
    if (win) win.close();
    alert('Erro ao gerar autorizacao: ' + (e as Error).message);
  }
}
